import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { documentTypeMapper } from "../../utils/mapper/mappers";
import { getRequiredDocumentList } from "../../actions/document.action";
import TopNav from "../../components/TopNav";
import { useDispatch, useSelector } from "react-redux";
import TokenHelpers from "../../utils/helpers/tokenHelper";
import { getAccountPathByName } from "../../utils/helpers/getAccountTypeName";
import DocumentCard from "../../components/document/DocumentCard";

export default function DocProcessing() {
  const history = useHistory();
  const dispatch = useDispatch();
  const account_type = TokenHelpers.getFromStorage("account_type");
  const url = getAccountPathByName(account_type);

  const {
    document: { requiredDocuments },
  } = useSelector(({ documentReducer }) => ({ document: documentReducer }));

  useEffect(() => {
    dispatch(getRequiredDocumentList(false));
  }, []);

  return (
    <>
      <div className=" doc_processing_color h-44 px-2 pt-3">
        <TopNav link={"/dashboard/user/secretariat"} />
        <div className="text-md text-3xl text-green-800 transcript_header">
          Document Processing
        </div>
        <div className="text-md w-2/3">
          Process all necessary documents easily and fast
        </div>
      </div>
      <div className="md:px-20">
        <div className="flex justify-center flex-wrap p-6 gap-5">
          {documentTypeMapper.map((doc) => {
            return (
              <DocumentCard
                type={url}
                name={doc.name}
                link={doc.path}
                history={history}
                dispatch={dispatch}
                requiredDocuments={requiredDocuments}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
